import { gql } from "@apollo/client";

export const CREATE_JOB_POSTING = gql`
  mutation CreateJobPosting($input: CreateJobPostingInput!) {
    createJobPosting(input: $input) {
      success
      message
      job {
        id
        title
        isActive
        publishedAt
        expiresAt
      }
    }
  }
`;

export const RENEW_JOB_POSTING = gql`
  mutation RenewJobPosting($id: ID!, $paypalCaptureId: String) {
    renewJobPosting(id: $id, paypalCaptureId: $paypalCaptureId) {
      success
      message
      job {
        id
        isActive
        publishedAt
        expiresAt
      }
    }
  }
`;

export const ARCHIVE_JOB_POSTING = gql`
  mutation ArchiveJobPosting($id: ID!) {
    archiveJobPosting(id: $id) {
      success
      message
      job { id isActive }
    }
  }
`;

export const APPLY_TO_JOB = gql`
  mutation ApplyToJob($input: ApplyToJobInput!) {
    applyToJob(input: $input) {
      success
      message
      alreadyApplied
      trackUrl
      application { id }
    }
  }
`;

export const UPDATE_JOB_APPLICATION = gql`
  mutation UpdateJobApplication($patch: UpdateJobApplicationInput!) {
    updateJobApplication(patch: $patch) {
      success
      updated
      message
      application {
        id
        jobId
        applicantName
        applicantEmail
        applicantPhone
        coverLetter
        resumeUrl
        status
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_JOB_APPLICATION_STATUS = gql`
  mutation UpdateJobApplicationStatus($id: ID!, $status: JobApplicationStatus!) {
    updateJobApplicationStatus(id: $id, status: $status) {
      success
      message
      application {
        id
        status
        updatedAt
      }
    }
  }
`;

export const UPDATE_JOB_POSTING = gql`
  mutation UpdateJobPosting($id: ID!, $patch: UpdateJobPostingInput!) {
    updateJobPosting(id: $id, patch: $patch) {
      success
      message
      job {
        id
        title
        isActive
        payMin
        payMax
        payUnit
        publishedAt
        expiresAt
        updatedAt
      }
    }
  }
`;

export const SAVE_JOB = gql`
  mutation SaveJob($jobId: ID!) {
    saveJob(jobId: $jobId) {
      success
      message
    }
  }
`;

export const UNSAVE_JOB = gql`
  mutation UnsaveJob($jobId: ID!) {
    unsaveJob(jobId: $jobId) {
      success
      message
    }
  }
`;

export const UPDATE_CANDIDATE_PROFILE = gql`
  mutation UpdateCandidateProfile($input: UpdateCandidateProfileInput!) {
    updateCandidateProfile(input: $input) {
      success
      message
      profile {
        userId
        openToWork
        phone
        resume { url name updatedAt }
        defaultCoverLetter
        qualifications
        updatedAt
      }
    }
  }
`;